module.exports = __webpack_public_path__ + "img/2_173.4dad3007.png";